import { render, staticRenderFns } from "./GallerySlideshow2.vue?vue&type=template&id=65ce9c64&scoped=true&"
import script from "./GallerySlideshow2.vue?vue&type=script&lang=js&"
export * from "./GallerySlideshow2.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlideshow2.vue?vue&type=style&index=0&id=65ce9c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce9c64",
  null
  
)

export default component.exports